export default {
  methods: {
    getExternalTooltip(unitText, labelSuffix = '', labels = null, transform = 'translate(-50%, 0)') {
      const getOrCreateTooltip = (chart) => {
        let tooltipEl = chart.canvas.parentNode.querySelector('div');

        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.style.background = '#FFFFFF';
          tooltipEl.style.border = '1px solid rgba(52, 58, 63, 0.3)';
          tooltipEl.style.borderRadius = '12px';
          tooltipEl.style.pointerEvents = 'none';
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.transform = transform;
          tooltipEl.style.transition = 'all .1s ease';
          tooltipEl.style.maxWidth = '500px';

          const container = document.createElement('div');
          container.style.margin = '0px';
          container.style.display = 'flex';
          container.style.width = '100%';
          container.id = 'content_div'

          tooltipEl.appendChild(container);
          chart.canvas.parentNode.appendChild(tooltipEl);
        }

        return tooltipEl;
      };

      // eslint-disable-next-line no-unused-vars
      const externalTooltipHandler = (context) => {
        // Tooltip Element
        const { chart, tooltip } = context;
        const tooltipEl = getOrCreateTooltip(chart);

        // Hide if no tooltip
        if (tooltip.opacity === 0) {
          tooltipEl.style.opacity = 0;
          return;
        }

        // Set Text
        if (tooltip.body) {
          // const titleLines = tooltip.title || [];
          const bodyLines = tooltip.body.map(b => b.lines);

          bodyLines.forEach((body, i) => {
            const colors = tooltip.labelColors[i];

            const colorBar = document.createElement('div');
            colorBar.style.background = colors.backgroundColor;
            colorBar.style.borderColor = colors.borderColor;
            colorBar.style.borderWidth = '2px';
            colorBar.style.marginRight = '10px';
            colorBar.style.height = '30px';
            colorBar.style.width = '4px';
            colorBar.style.display = 'flex';
            colorBar.style.borderRadius = '3px'
            const dataIndex = tooltip.dataPoints[0].dataIndex;

            let label = labels != null ? labels[dataIndex] : tooltip.dataPoints[0].label
            const labelText = document.createTextNode(label + labelSuffix);
            const labelTextDiv = document.createElement('div');
            labelTextDiv.style.background = '#ededed';
            labelTextDiv.style.marginRight = '10px';
            labelTextDiv.style.padding = '5px 10px';
            labelTextDiv.style.borderRadius = '16px'
            labelTextDiv.style.textAlign = 'center';
            labelTextDiv.style.alignItems = 'center';
            labelTextDiv.style.display = 'flex';
            labelTextDiv.style.justifyContent = 'center';
            labelTextDiv.style.fontFamily = 'SF Pro';
            labelTextDiv.style.fontStyle = 'normal';
            labelTextDiv.style.fontWeight = '400';
            labelTextDiv.style.fontSize = '13px';
            labelTextDiv.style.lineHeight = '18px';
            labelTextDiv.style.color = '#343A3F';
            labelTextDiv.style.whiteSpace = 'nowrap';

            labelTextDiv.appendChild(labelText);

            const valueText = document.createTextNode(tooltip.dataPoints[i].formattedValue + unitText)
            const valueTextDiv = document.createElement('div');
            valueTextDiv.style.display = 'flex';
            valueTextDiv.style.fontFamily = 'SF Pro';
            valueTextDiv.style.fontStyle = 'normal';
            valueTextDiv.style.fontWeight = '700';
            valueTextDiv.style.fontSize = '14px';
            valueTextDiv.style.lineHeight = '140%';
            valueTextDiv.style.alignItems = 'center';
            valueTextDiv.style.textAlign = 'center';
            valueTextDiv.style.letterSpacing = '0.1px';
            valueTextDiv.style.color = '#4d4d4d'
            valueTextDiv.appendChild(valueText);

            const divContent = tooltipEl.querySelector('#content_div');
            while (divContent.firstChild) {
              divContent.firstChild.remove();
            }

            divContent.appendChild(colorBar);
            divContent.appendChild(labelTextDiv);
            divContent.appendChild(valueTextDiv);
          });
        }

        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1;
        tooltipEl.style.left = positionX + 'px';
        tooltipEl.style.top = positionY + tooltip.caretY + 'px';
        tooltipEl.style.font = tooltip.options.bodyFont.string;
        tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
      };

      return externalTooltipHandler;
    }
  }
}
